(() => {
  const init = () => {
    document.querySelectorAll('[data-nutry-logo-list]').forEach((section) => {
      if (section.dataset.nutryLogoListReady === 'true') return;

      section.dataset.nutryLogoListReady = 'true';

      section.querySelectorAll('img, a').forEach((element) => {
        element.setAttribute('draggable', 'false');
        element.addEventListener('dragstart', (event) => event.preventDefault());
      });

      const viewport = section.querySelector('[data-nutry-logo-viewport]');
      const track = section.querySelector('[data-nutry-logo-track]');
      const shouldPause = section.dataset.pauseOnInteraction === 'true';

      if (!viewport || !track || track.dataset.marquee !== 'true' || !shouldPause) return;

      let resumeTimer = null;

      const pause = () => {
        viewport.classList.add('is-paused');

        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
        }
      };

      const resume = () => {
        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
        }

        resumeTimer = window.setTimeout(() => {
          viewport.classList.remove('is-paused');
        }, 1800);
      };

      viewport.addEventListener('pointerdown', pause, { passive: true });
      viewport.addEventListener('touchstart', pause, { passive: true });
      viewport.addEventListener('wheel', pause, { passive: true });
      viewport.addEventListener('pointerup', resume, { passive: true });
      viewport.addEventListener('pointercancel', resume, { passive: true });
      viewport.addEventListener('touchend', resume, { passive: true });
      viewport.addEventListener('mouseleave', resume, { passive: true });
      viewport.addEventListener('scroll', resume, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();